/* eslint no-unused-vars: off, @typescript-eslint/no-unused-vars: off */
/**
 * Device Management
 * Device Manager API CRUD https://bitbucket.org/nwaveio/device-management-openapi/src/master/
 *
 * The version of the OpenAPI document: 2.1.5
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * @export
 * @interface PositionUpdateFields
 */
export interface PositionUpdateFields {
    /**
     * @type {number}
     * @memberof PositionUpdateFields
     */
    lat: number;
    /**
     * @type {number}
     * @memberof PositionUpdateFields
     */
    lon: number;
    /**
     * `Group Primary Key`
     * @type {number}
     * @memberof PositionUpdateFields
     */
    group_id: number;
    /**
     * @type {number}
     * @memberof PositionUpdateFields
     */
    group_inner_id: number;
    /**
     * Names String. For example zone name, group name or custom_id
     * @type {string}
     * @memberof PositionUpdateFields
     */
    custom_id: string | null;
}
